import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { InteractionsApi } from 'sustainment-component';

@Component({
    selector: 'app-dashboard-connection-request',
    templateUrl: './connection-request.component.html',
    styleUrls: ['./connection-request.component.scss'],
    standalone: false
})
export class ConnectionRequestComponent {
  public constructor(
    private _interactionsApi: InteractionsApi,
    private confirmationService: ConfirmationService
  ) {}

  @Input() public connectionRequest: {
    name: string;
    note: string;
    logo: string;
    sustainmentId: string;
  };

  @Output() public connectionAccepted = new EventEmitter<void>();
  @Output() public companyClicked = new EventEmitter<void>();
  @Output() public connectionDeclined = new EventEmitter<void>();

  public disableButton = signal<'decline' | 'accept' | null>(null);

  public companyClick(event: Event): void {
    event.stopPropagation();
    this.companyClicked.emit();
  }

  public acceptConnectionRequest(): void {
    this.connectionAccepted.emit();
    this.disableButton.set('accept');
  }

  public declineConnectionRequest(): void {
    this.confirmationService.confirm({
      header: 'Decline connection request',
      message:
        'Declining this connection request will remove this chat. You will still be able to communicate on any project related chats.',
      acceptLabel: 'Continue',
      rejectLabel: 'Cancel',
      acceptIcon: 'null',
      rejectIcon: 'null',
      reject: () => {},
      accept: () => {
        this.disableButton.set('decline');

        this._interactionsApi
          .declineConnection(this.connectionRequest.sustainmentId)
          .subscribe(
            () => {
              location.reload();
              this.connectionDeclined.emit();
            },
            () => {
              this.disableButton.set(null);
            }
          );
      }
    });
  }
}
